<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="transparency.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
                @blur="$emit('on-name-change', transparency.name)"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="types">Type</label>
            <v-select
                v-model="transparency.type"
                :options="types"
                :clearable="false"
            />
        </div>

        <div class="col-6 form-group">
            <label for="meetingDate">Meeting date</label>
            <input
                id="meetingDate"
                v-model="transparency.meetingDate"
                type="date"
                class="form-control"
                :class="{
                    'is-invalid': hasError('meetingDate')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('meetingDate') }}
            </div>
        </div>

        <div v-if="!editMode || (editMode && transparency.id)" class="col-12">
            <small v-if="hasError('content')" style="color: #dc3545">
                {{ getError('content') }}
            </small>

            <content-builder
                v-model="transparency.content"
                :sections="sections"
                label="Content"
            />
        </div>
    </div>
</template>

<script>
import ContentBuilder from '@/components/elements/ContentBuilder';
import types from '@/../../common/transparency-type';

export default {
    components: {
        ContentBuilder
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            transparency: {},
            types,
            sections: {
                header: false,
                image: false,
                gallery: false,
                video: false,
                form: false,
                pdf: true,
                audio: true
            }
        };
    },

    watch: {
        transparency() {
            this.$emit('input', this.transparency);
        }
    },

    created() {
        this.transparency = { ...this.value };

        if (!this.transparency.content) {
            this.transparency.content = [];
        }
    },

    methods: {
        hasError(key) {
            return (
                this.validation.transparency[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.transparency,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
